export default {
  'home.join.title':
    '<h3>Membership Rules & Application Guide</h3>' +
    '<b>Thank you for your interest in Chubby Men’s Culture and your desire to join us!</b>' +
    '<br />' +
    'To maintain order and quality of interactions within our Association, please carefully read the following rules and membership requirements, and confirm your understanding and agreement to comply.',
  'home.join.paragraph_1':
    '<h4>📌 Membership Eligibility </h4>' +
    '<ol>' +
    '<li>' +
    '<b>Age & Status Requirement</b>:<br />' +
    'Applicants must be <b>adult men</b> of legal age, able to take full legal responsibility.' +
    '</li>' +
    '<li>' +
    '<b>Gender & Sexual Orientation Requirement</b>:<br />' +
    'Our Association is intended exclusively for <b>biological males who are attracted to men</b>.' +
    'This is not discrimination, but a principle based on our cultural mission. Just as a vegetarian restaurant serves only vegetarian food, or women-only spaces restrict male entry, our focus is to provide a safe and secure environment for a specific identity group. Mutual respect is expected.' +
    '</li>' +
    '<li>' +
    '<b>Value Alignment</b>:<br />' +
    'Applicants must <b>understand and agree with the mission of the Association</b>,' +
    'support the promotion of GMPD culture, and treat community members with respect and friendliness.' +
    '</li>' +
    '</ol>',
  'home.join.paragraph_2':
    '<h4>🚫 Prohibited Conduct</h4>' +
    'To protect the image of the Association and the rights of our members, the following behaviors are <b>strictly prohibited</b>. Offenders may be warned, suspended, or expelled depending on the severity:' +
    '<ul>' +
    '<li>' +
    '<b>Discrimination or derogatory remarks against gay men</b>' +
    '</li>' +
    '<li>' +
    '<b>Discrimination or derogatory remarks about body diversity (whether fat or thin)</b>' +
    '</li>' +
    '<li>' +
    '<b>Violations during events or online interactions that disrupt order or harm the image of the Association</b>' +
    '</li>' +
    '<li>' +
    '<b>Misusing the Association’s name for harassment, infringement, fraud, or misleading actions</b>' +
    '</li>' +
    '</ul>',
  'home.join.paragraph_3':
    '<h4>✍️ Membership Application Process</h4>' +
    '<ol>' +
    '<li>' +
    '<b>Fill out the Membership Form</b>' +
    '<br />' +
    'Provide truthful personal information and self-introduction. The content will be used solely for review and internal management, and will not be disclosed externally.' +
    '</li>' +
    '<li>' +
    '<b>Review & Consent to Membership Rules</b>' +
    '<br />' +
    'Ensure that you fully understand the rules on this page and confirm compliance with all regulations.' +
    '</li>' +
    '<li>' +
    '<b>Review & Notification</b>' +
    '<br />' +
    'The Association will review applications to confirm eligibility and alignment with our mission. Results will be sent via email.' +
    '</li>' +
    '</ol>',
  'home.join.paragraph_4':
    '<h4>🤝 Building a Friendly Space Together</h4>' +
    'We aim to create a home for chubby men. Whether you are P, M, G, or D, as long as you are willing to respect, understand, and support one another, you are sincerely welcome.',
  'home.join.paragraph_5':
    'If you have any questions, please contact us via the form or our social media channels.',
  'home.purpose.title':
    '<h3>About the Association & Our Mission</h3>' +
    '<b>Chubby Men’s Culture Promotion Association</b>' +
    'is a community group dedicated to promoting GMPD culture. With respect for body diversity and the creation of positive values, we aim to establish a welcoming community space in Taiwan for big-bodied men.',
  'home.purpose.paragraph_1':
    '<h4>About the Association</h4>' +
    'GMPD culture originated in Japan, focusing on four types of attractive, distinctive body shapes:' +
    '<ul>' +
    '<li>' +
    '<b>G (Gachi)</b>: Muscular and solidly built' +
    '</li>' +
    '<li>' +
    '<b>M (Muchi)</b>: Slightly fatty, firm, and full-bodied' +
    '</li>' +
    '<li>' +
    '<b>P (Pocchari)</b>: Rounded, cute, and soft' +
    '</li>' +
    '<li>' +
    '<b>D (Debu)</b>: Big-bodied, soft, and prominent' +
    '</li>' +
    '</ul>',
  'home.purpose.paragraph_2':
    'In mainstream society, “fatness” is often labeled negatively and directly linked to illness. However, medical research shows that the relationship between body type and health is complex. Many so-called obesity-related conditions involve genetics, environment, and lifestyle factors. Therefore, it is inaccurate and irresponsible to treat all non-standard body types as inherently unhealthy.' +
    '<br />' +
    'We believe that <b>body diversity itself is a culture and a form of beauty</b>. The Chubby Men’s Culture Promotion Association does not deny the importance of health, but focuses on social and psychological dimensions to provide a space where individuals can confidently be themselves.',
  'home.purpose.paragraph_3':
    '<h4>Our Mission</h4>' +
    '<i>We may not be able to erase body discrimination from the world.</i>' +
    '<br />' +
    '<i>But at the very least, we can create a place where chubby men and those who admire them</i>' +
    '<br />' +
    '<i>can meet, understand each other, share life, and support one another.</i>',
  'home.purpose.paragraph_4':
    'Our main activities include:' +
    '<ol>' +
    '<li>' +
    '<b>Cultural Exchange Events</b>: Hosting book fairs, doujin exhibitions, and creative workshops to spread chubby men’s culture through art and creation.' +
    '</li>' +
    '<li>' +
    '<b>Health & Body Exchange</b>: Sharing health information, fitness knowledge, and body care experiences to support and encourage one another.' +
    '</li>' +
    '<li>' +
    '<b>Knowledge Sharing</b>: Collecting and sharing relevant publications, research, and cultural works domestically and internationally.' +
    '</li>' +
    '</ol>',
};
